<template>
  <Select
    v-model="weight_magnitude"
    :options="weightOptions"
    option-label="label"
    option-value="value"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import Select from "primevue/select";
import { WeightUnitEnum } from "@/api/model";

const props = defineProps<{
  min: number;
  max: number;
}>();

const weight_magnitude = defineModel<number | null>();
const unit = defineModel<WeightUnitEnum>("unit", {
  default: WeightUnitEnum.lbs,
});

const weightOptions = computed(() => {
  return Array.from({ length: props.max - props.min + 1 }, (_, i) => ({
    label: `${props.min + i} ${unit.value}`,
    value: props.min + i,
  }));
});
</script>
